import React from "react";

import { useTranslation } from "react-i18next";

import { FirstTeamToScore } from "@data-types/sport-stats/SportStatsTypes";
import Graph from "../Graph";
import RecentGames from "../RecentGames";

export default function FirstTeamToScoreStatistics(props: {
	homeTeam: FirstTeamToScore["data"];
	awayTeam: FirstTeamToScore["data"];
}) {
	const { t } = useTranslation();

	return (
		<>
			<RecentGames
				homeTeamEventCount={props.homeTeam?.eventCount}
				awayTeamEventCount={props.awayTeam?.eventCount}
			/>
			<Graph
				title={t(
					"EVENT.STATISTICS.BETTING_TYPE_STATS.SCORED_FIRST_GOAL"
				)}
				home={t("OFFER.COMPETITORS.HOME")}
				away={t("OFFER.COMPETITORS.AWAY")}
				data={{
					homeValue: props.homeTeam?.scoredFirstGoal,
					awayValue: props.awayTeam?.scoredFirstGoal,
				}}
				isPercentage
			/>
		</>
	);
}
